const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const gaEnabled = !!GA_ID;

export function initGA() {
  if (!GA_ID || window.__gaLoaded) return;
  // The base Google tag (gtag.js) is loaded statically in index.html <head>.
  // If it's already present, don't inject a second tag — just reuse it.
  if (window.gtag) {
    window.__gaLoaded = true;
    return;
  }
  window.__gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
}

export function trackPage(path) {
  if (!GA_ID || !window.gtag) return;
  window.gtag("config", GA_ID, { page_path: path });
}

// Maps our internal event names to Meta (Facebook) Pixel standard events.
const META_EVENT_MAP = {
  generate_lead: "Lead",
  enquire_listing: "Lead",
  newsletter_subscribe: "Subscribe",
  view_market_report: "ViewContent",
  contact_call: "Contact",
  view_mls_listing: "ViewContent",
};

export function trackEvent(name, params = {}) {
  // Google Analytics
  if (GA_ID && window.gtag) window.gtag("event", name, params);
  // Meta Pixel
  if (window.fbq) {
    const metaEvent = META_EVENT_MAP[name];
    if (metaEvent) window.fbq("track", metaEvent, params);
    else window.fbq("trackCustom", name, params);
  }
}

export function trackPageMeta() {
  if (window.fbq) window.fbq("track", "PageView");
}
